<div nxRow class="pair-column">
    <div nxCol="8">{{ 'ma-insurance.life.dateStart' | translate }}</div>
    <div nxCol="4">{{ maInsuranceExtend.dateStart|dateFormat }}</div>
</div>
<div nxRow *ngIf="maInsuranceExtend.dateEnd" class="pair-column">
    <div nxCol="8">{{ 'ma-insurance.life.dateEnd' | translate }}</div>
    <div nxCol="4">{{ maInsuranceExtend.dateEnd|dateFormat }}</div>
</div>